export enum TripProfileTypeEnum {
    AMDD = 'AMDD',
    PMDD = 'PMDD',
    CPPC = 'CPPC'
}

export const TripProfileTypeLabelMap: Record<TripProfileTypeEnum, string> = {
    [TripProfileTypeEnum.AMDD]: 'AMDD',
    [TripProfileTypeEnum.PMDD]: 'PMDD',
    [TripProfileTypeEnum.CPPC]: 'Flexi'
};
